//Javascript for the WECAN Employer Questions functionality
app.EmployerQuestions = (
    function () {
        var questions = {
            //Index Page
            Index: function () {
                $("#resetFiltersButton").on("click", function () {
                    $("#SelectedPositionTypeId").val(null);
                    $("#SelectedStatusId").val(null);
                    $("#SearchText").val(null);
                    app.page.components["QuestionSetsGrid"][0].refreshGrid();
                });
            }
        };
        return questions;
    }()
);